import * as React from 'react'

export type DescriptionProps = {
  children: React.ReactNode
}

export const Description = ({ children }: DescriptionProps) => (
  <p className="mb-5 text-gray-600">{children}</p>
)
